/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import {
  deleteValidateRemoveUserThunk,
  deleteRemoveUserAccountThunk,
  postDeleteUserAccountRejectedThunk,
  postDeleteUserAccountThunk,
} from './user.remove.thunk';
import { useUserAccounts } from '../userAccounts/useUserAccounts';
import {
  selectError,
  selectConfirmDialog,
  selectErrorDialog,
  toggleRemoveUserConfirmDialog,
  toggleErrorDialog,
  selectStatus,
  selectVerifyDialog,
  toggleVerifyDialog,
  toggleSuccessDialog,
  selectSuccessDialog,
} from './user.remove.slice';

export default function useRemoveUserAccount() {
  const [isLoading, setIsLoading] = useState(false);
  const [deleteButtonActive, setDeleteButtonActive] = useState();

  const dispatch = useDispatch();

  const status = useSelector(selectStatus);
  const { user } = useUserAccounts();
  const error = useSelector(selectError);
  const confirmationDialog = useSelector(selectConfirmDialog);
  const verifyDialog = useSelector(selectVerifyDialog);
  const successDialog = useSelector(selectSuccessDialog);
  const errorDialog = useSelector(selectErrorDialog);

  useEffect(() => {
    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const validateRemoveUser = () => {
    dispatch(deleteValidateRemoveUserThunk({ userId: user.id }));
  };

  const onToggleConfirmDialog = (visible) => {
    dispatch(toggleRemoveUserConfirmDialog(visible));
  };

  const onSubmitConfirmDialog = () => {
    dispatch(toggleRemoveUserConfirmDialog(false));
    setDeleteButtonActive(false);
    dispatch(toggleVerifyDialog(true));
  };

  const onToggleVerifyDialog = (visible) => {
    dispatch(toggleVerifyDialog(visible));
  };

  const onSubmitVerifyDialog = () => {
    dispatch(deleteRemoveUserAccountThunk({ userId: user.id }));
  };

  const onToggleErrorDialog = (visible) => {
    dispatch(toggleErrorDialog(visible));
  };

  const onSubmitErrorDialog = () => {
    dispatch(toggleErrorDialog(false));
    dispatch(postDeleteUserAccountRejectedThunk({ organizationId: user.currentOrganizationId }));
  };

  const onKeyUp = (value) => {
    if (user.username.toLowerCase() === value.toLowerCase()) {
      setDeleteButtonActive(true);
    } else {
      setDeleteButtonActive(false);
    }
  };

  const onToggleSuccessDialog = (visible) => {
    dispatch(toggleSuccessDialog(visible));
    if (!visible && typeof error === 'undefined') {
      dispatch(postDeleteUserAccountThunk());
    }
  };

  return {
    isLoading,
    validateRemoveUser,
    error,
    confirmationDialog,
    onToggleConfirmDialog,
    onSubmitConfirmDialog,
    verifyDialog,
    onToggleVerifyDialog,
    onSubmitVerifyDialog,
    onKeyUp,
    deleteButtonActive,
    successDialog,
    onToggleSuccessDialog,
    errorDialog,
    onToggleErrorDialog,
    onSubmitErrorDialog,
  };
}
